import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {Editor, EditorPanel, EditorColumn} from '../editor-components';
import ExpoMetadata from './expo-metadata';
import AssignedEditors from './assigned-editors';
import ShowList from './show-list';

/** @class ExpoEditor
  * A component for editing virtual expos.
  */
export default class ExpoEditor extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of ExpoEditor
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.expoID = this.props.match.params.expoID;
    this.dataURL = `/expos/${this.expoID}`
  }
  /** @method componentWillMount
    * Binds the component to the firebase database
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL, 'expo');
  }
  /** @method componentWilUnmount
    * Unbinds the component to the firebase database
    */
  componentWillUnmount() {
    this.unbind('expo');
  }
  /** @method render
    * Renders the component
    */
  render() {
    if(!this.state.expo) return '';
    console.log('expo',this.state.expo)
    return (
      <Editor>
        <EditorPanel>
          <EditorColumn>
            <ExpoMetadata {...this.state.expo.metadata}
              dataURL={this.dataURL + '/metadata'}
              expoID={this.expoID}
              />
            <ShowList
              name={this.state.expo.metadata.name}
              dataURL={this.dataURL + '/shows'}
              shows={this.state.expo.shows} />
          </EditorColumn>
          <EditorColumn>
            <AssignedEditors
              dataURL={this.dataURL}
              assignedEditors={this.state.expo.editors || {}}
              />
          </EditorColumn>
        </EditorPanel>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/expo-editor/expo-editor.js